import type { Profile } from '../types/profile';

export const PROFILE_SEGMENT: Record<Profile, string> = {
  student: 'aluno',
  mentor: 'mentor',
  owner: 'owner',
};

const SEGMENT_PROFILE: Record<string, Profile> = {
  aluno: 'student',
  mentor: 'mentor',
  owner: 'owner',
};

export function profileFromSegment(segment?: string): Profile | undefined {
  return segment ? SEGMENT_PROFILE[segment] : undefined;
}

export function profileHomePath(profile: Profile) {
  return `/${PROFILE_SEGMENT[profile]}`;
}

export function articlePath(profile: Profile, category: string, slug: string) {
  return `${profileHomePath(profile)}/${category}/${slug}`;
}
